'use strict';

module.exports = (function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  }
  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
  };
})();



//////////////////
// WEBPACK FOOTER
// ./~/perfect-scrollbar/src/js/lib/guid.js
// module id = 518
// module chunks = 9